module.exports = __webpack_public_path__ + "img/group121.011a08e6.png";